import { useCurrentClientIfAvailable } from 'src/clients/context/CurrentClientProvider';
import { useNavigate, useParams, useSearchParams } from 'react-router';
import React from 'react';
import { FinancialItemDataDynamicForm } from 'src/financial/financial-data/financial-item/FinancialItemDataDynamicForm';
import { useContentMeta } from 'src/UI/app-container';
import { ChatMode } from 'src/UI/app-container/chat/types';
import { ClientListItem } from 'src/admin/users/types';
import { useFlags } from 'src/feature-flags/FlagsHook';
import {
  financialsReturnPath,
  RETURN_TO_PARAM,
} from 'src/financial/financial-data/financial-item/rework/returnPath';
type Params = {
  product: string;
};

export default function CreateFinancialItemPage() {
  const { product } = useParams<Params>();
  const { client, clientId } = useCurrentClientIfAvailable();
  useContentMeta({ pageType: 'client', entityId: clientId, chatMode: ChatMode.CLIENT });

  if (product && client) {
    return <CreateFinancialItem product={product} client={client} />;
  }
}

type Props = {
  product: string;
  client: ClientListItem;
};

function CreateFinancialItem({ product, client }: Props) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { flagEnabledFinancialRework } = useFlags();

  const handleSave = (id: string) => {
    navigate(
      flagEnabledFinancialRework
        ? financialsReturnPath(client.id, searchParams.get(RETURN_TO_PARAM))
        : `/client/${client.id}/financial-items/${product}/${id}`,
    );
  };

  const backHref = `/client/${client.id}/financial-data/create`;

  return (
    <FinancialItemDataDynamicForm
      product={product}
      client={client}
      onSuccessfulSave={handleSave}
      backHref={backHref}
    />
  );
}
